import formTypes from "./form.types";

const INITIAL_STATE = {
    period: 0,
    portal: '',
    HoldOver:{},
    lastPrice: null,
    receivedForm: '',
    receivedExcel: '',
};

const formReducer = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case formTypes.SET_PERIOD:
            return{
                ...state,
                period: actions.payload
            };
        case formTypes.SET_PORTAL:
            return{
                ...state,
                portal: actions.payload
            };
        case formTypes.SET_HOLD_OVER:
            return{
                ...state,
                HoldOver: actions.payload
            };
        case formTypes.MODIFY_LAST_PRICE:
            return{
                ...state,
                lastPrice: actions.payload
            };
        case formTypes.SET_RECEIVED_FORM:
            return{
                ...state,
                receivedForm: actions.payload
            };
        case formTypes.SET_RECEIVED_EXCEL:
            return{
                ...state,
                receivedExcel: actions.payload
            };
        default :
            return state
    }
};

export default formReducer;